<template>
  <div class="flex flex-col w-full mx-auto items-center mt-3 max-w-2xl gap-3 mb-4">
    <h1 class="mb-2">{{ title }}</h1>
    <slot name="top"></slot>
    <div>
      <DirectusErrorView v-if="error" @retry="refresh" :status="status" />
      <div v-if="resultArray" v-html="resultArray[0].content" id="content"></div>
    </div>
    <slot name="bottom"></slot>
  </div>
</template>
<script setup lang="ts">

const props = defineProps<{
  collection: string;
  title: string;
}>();

const { getSingletonItem } = useDirectusItems();
const content = ref<string | null>();
const locale = usePlatformSettings().locale;

const {
  data: resultArray,
  error, refresh, status
} = await useAsyncData<DirectusPageContent[]>(() => getSingletonItem<DirectusPageContent[]>({
  collection: props.collection,
  params: {
    filter: {
      languages_code: locale.value
    }
  }
}), {
  watch: locale
});

</script>
